<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card height="auto">
          <v-card-title> Lista de Usuarios/Zonas </v-card-title>
          <v-card-text class="pa-0 pa-sm-4">
            <div class="px-2">
              <v-row dense class="mt-n4">
                <v-col cols="12">
                  <v-row align="center">
                    <v-col cols="12" sm="8" md="9">
                      <v-autocomplete
                        outlined
                        dense
                        label="Selecciona distribuidor"
                        hide-no-data
                        :items="distributors"
                        item-text="companyName"
                        clearable
                        v-model="distributorSelected"
                        return-object
                        hide-details
                        class="white rounded-lg"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" md="3" class="text-end">
                      <v-btn
                        color="primary"
                        rounded
                        @click="showAddDistributorModal = true"
                        small
                        elevation="0"
                        block
                      >
                        <v-icon left size="18"> mdi-plus </v-icon>
                        Nuevo
                      </v-btn>
                    </v-col>
                    <v-col cols="12" v-if="distributorSelected" class="pt-1">
                      <v-btn
                        color="secondary"
                        @click="showUpdateDistributorModal = true"
                        text
                        small
                        class="px-0"
                      >
                        <v-icon left size="18"> mdi-pencil </v-icon>
                        Editar distribuidor
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" v-if="distributorSelected">
                  <v-row dense class="text-body-2">
                    <v-col cols="12" sm="6">
                      <div class="grey--text text--darken-1">Nombre:</div>
                      <div class="font-weight-bold">{{ distributorSelected.companyName }}</div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="grey--text text--darken-1">Teléfono:</div>
                      <div class="font-weight-bold">{{ distributorSelected.phone }}</div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="grey--text text--darken-1">Correo:</div>
                      <div class="font-weight-bold">{{ distributorSelected.email }}</div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="grey--text text--darken-1">Laboratorios:</div>
                      <div class="font-weight-bold">
                        <span v-for="(lab, index) in distributorSelected.laboratories" :key="index">
                          {{ lab.name }}{{ index + 1 < distributorSelected.laboratories.length ? ', ' : '' }}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="mt-n2">
                <v-col cols="12" class="px-0">
                  <v-tabs v-model="tabs" color="primary" grow class="rounded-lg">
                    <v-tab>Usuarios</v-tab>
                    <v-tab>Zonas</v-tab>
                    <v-tab-item>
                      <UserTable />
                    </v-tab-item>
                    <v-tab-item>
                      <ZoneTable />
                    </v-tab-item>
                  </v-tabs>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <add-distributor-modal
      v-model="showAddDistributorModal"
      v-if="showAddDistributorModal"
      @fetchData="fetchDistributors"
    />
    <update-distributor-modal
      v-model="showUpdateDistributorModal"
      v-if="showUpdateDistributorModal"
      @fetchData="mapNewDistributor"
    />
  </v-container>
</template>

<script>
//components
import UserTable from "@/components/users/UserTable.vue";
import ZoneTable from "@/components/users/ZoneTable.vue";
import AddDistributorModal from "../components/users/modals/AddDistributorModal.vue";
import UpdateDistributorModal from "../components/users/modals/UpdateDistributorModal.vue";
//vuex
import { mapActions, mapMutations } from "vuex";

export default {
  components: {
    UserTable,
    ZoneTable,
    AddDistributorModal,
    UpdateDistributorModal,
  },
  data: () => ({
    tabs: 0,
    distributors: [],
    distributorSelected: null,
    showAddDistributorModal: false,
    showUpdateDistributorModal: false,
  }),
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("user", ["getDistributors"]),
    ...mapMutations("user", ["SET_DISTRIBUTOR_SELECTED"]),
    async fetchDistributors() {
      try {
        let response = await this.getDistributors();
        if (!response) throw response;
        this.distributors = response.distributors;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar distribuidores",
          timeout: 5000,
        });
      }
    },
    async mapNewDistributor() {
      await this.fetchDistributors();
      if (this.distributorSelected) {
        this.distributorSelected = this.distributors.find(
          (element) => element._id == this.distributorSelected._id
        );
      }
    },
  },

  async mounted() {
    await this.fetchDistributors();
    this.distributorSelected = null;
    this.SET_DISTRIBUTOR_SELECTED(null);
  },
  watch: {
    distributorSelected(value) {
      this.SET_DISTRIBUTOR_SELECTED(value);
    },
  },
};
</script>
